<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
========================================================================================== -->

<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
        />

        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />

        <vx-tooltip
          class="cursor-pointer navbar-fuzzy-search ml-4 mt-2"
          :text="dbData.s"
          position="right"
        >
          <feather-icon @click.stop="dbSettings = !dbSettings" :class="`text-${dbData.m}`" icon="DatabaseIcon" />
          <feather-icon @click.stop="dbSettings = !dbSettings" :class="`text-${dbData.m}`" :icon="`${type(dbData.s)}Icon`" />
        </vx-tooltip> 
        <span class="ml-2 mt-1" v-if="dbData.a">Database Error</span>

        <vs-popup
            class="holamundo"
            title="Database Settings"
            :active.sync="dbSettings"
          >
            <div class="vx-row">
                    <div class="vx-col w-full ml-4">
                      <span class="text-sm"
                        >We keep secure cloud periodic backups of your data
                        encrypted at our database servers</span
                      >
                    </div>
                     <div class="vx-row ml-6 mr-6 mt-4">
                          <div class="vx-col">
                            <feather-icon @click.stop="dbSettings = !dbSettings" :class="`text-${dbData.m}`" icon="DatabaseIcon" />
                            <feather-icon @click.stop="dbSettings = !dbSettings" :class="`text-${dbData.m}`" :icon="`${type(dbData.s)}Icon`" />
                          </div>
                          <span class=" vx-col text-sm">{{ dbData.s }}</span>
                        </div>
                    <div v-if="allow_backups && this.$acl.check('admin')" class="vx-row w-full ml-4 mr-4">
                      <!-- <vs-divider>Database</vs-divider> -->
                      <div class="vx-col w-full mt-2">
                        <span class="text-sm">
                          To create a new database and migrate, please contact our Support Team.</span
                        >
                      </div>
                      <div v-if="!create_db" class="vx-col w-full mt-2">
                        <vs-input
                          label="Database ID"
                          v-model="link_db"
                          class="w-full"
                          name="remote_db"
                          v-validate="'required'"
                        />
                        <span class="text-sm">
                          Enter external installation id to link this database
                          with the external database.</span
                        >
                        <br />
                        <span class="text-danger">{{
                          errors.first("remote_db")
                        }}</span>
                      </div>
                      <div class="vx-col md:w-1/3 w-full mt-5">
                        <vs-select
                          v-model="protocol"
                          class="w-full select-large"
                          label="Protocol"
                        >
                          <vs-select-item
                            :key="index"
                            :value="item"
                            :text="item"
                            v-for="(item, index) in protocolOptions"
                            class="w-full"
                          />
                        </vs-select>
                      </div>
                      <div class="vx-col md:w-1/3 w-full mt-5">
                        <vs-input
                          v-on:keyup.alt.67="overide"
                          label="Remote DB Url"
                          v-model="remote_url"
                          class="w-full"
                          name="remote_url"
                          v-validate="{ required: true }"
                        />
                        <span class="text-danger">{{
                          errors.first("remote_url")
                        }}</span>
                      </div>
                      <div class="vx-col md:w-1/3 w-full mt-5">
                        <vs-input
                          label="Remote DB Port"
                          v-model="remote_port"
                          class="w-full"
                          name="remote_port"
                          v-validate="'numeric'"
                        />
                        <span class="text-danger">{{
                          errors.first("remote_port")
                        }}</span>
                      </div>
                      <div v-if="false" class="vx-col md:w-1/2 w-full mt-5">
                        <vs-input
                          label="Remote DB Username"
                          v-model="remote_username"
                          class="w-full"
                          name="remote_username"
                          v-validate="'alpha'"
                        />
                        <span class="text-danger">{{
                          errors.first("remote_username")
                        }}</span>
                      </div>
                      <div v-if="false" class="vx-col md:w-1/2 w-full mt-5">
                        <vs-input
                          type="password"
                          label="Remote DB Password"
                          v-model="remote_password"
                          class="w-full"
                          name="remote_password"
                        />
                        <span class="text-danger">{{
                          errors.first("remote_password")
                        }}</span>
                      </div>
                    </div>

                    <div v-if="dbDataValid && this.$acl.check('admin')" @click="updateDB"
              class="w-full ml-6 mr-6  mt-6 btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-white bg-primary"
            >
              <feather-icon icon="CheckIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-white">Update</span>
            </div>
                  <span class="mt-2 vx-col ml-6 mr-6 text-sm">
                          This window will close automatically after {{ timeout }} second{{ timeout == 1 ? '' : '' }}s.</span
                        >
                  </div>
          </vs-popup>



        <vs-spacer />

        <!-- <i18n /> -->

        <feather-icon
          @click="toggleTheme"
          :icon="isThemedark === 'dark' ? 'SunIcon' : 'MoonIcon'"
          svgClasses="cursor-pointer navbar-fuzzy-search ml-4"
        />

        <!-- <search-bar /> -->

        <notification-drop-down class="ml-4" />

        <profile-drop-down />

        <div v-if="window" class="vx-row ml-4">
          <vx-tooltip position="bottom" text="Minimize">
            <feather-icon
              @click="window.minimize()"
              class="ml-2 mt-2 mr-1 hover:text-primary"
              icon="MinusIcon"
              :svgClasses="['h-5 w-5 stroke-current', textColor]"
            ></feather-icon>
          </vx-tooltip>
          <vx-tooltip position="bottom" text="Close">
            <feather-icon
              @click="closeApp"
              class="ml-2 mt-2 mr-1 hover:text-danger"
              icon="XIcon"
              :svgClasses="['h-5 w-5 stroke-current', textColor]"
            ></feather-icon>
          </vx-tooltip>
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
import I18n from "./components/I18n.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";

import idb from "@/db/idb";
import FormValidationTypesVue from '../../../views/forms/form-validation/FormValidationTypes.vue';

import PouchDb from "pouchdb"
import p from "@/http/pouch/index.js";

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  components: {
    Bookmarks,
    I18n,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
  },
  data() {
    return {
      app: window.require,
      dbSettings: false,

      timeout: 60,
      timer: null,

      allow_backups: true,
      create_db: false,
      link_db: "",
      dbOptions: [
        {
          label: "Create new database",
          value: true,
        },
        {
          label: "Link existing database",
          value: false,
        },
      ],
      protocol: "https",
      protocolOptions: ["https", "http"],
      remote_url: "db.vue.co.ke",
      remote_port: 6984,
      remote_username: process.env.VUE_APP_DB_USERNAME,
      remote_password: process.env.VUE_APP_DB_PASSWORD,
      overide_credentials: false,
      db: null
    };
  },
  watch: {
    protocol(v) {
      switch (this.protocol) {
        case "https":
          this.remote_port = 6984;
          break;

        default:
          this.remote_port = 5984;
          break;
      }
    },
    dbSettings(v) {
      switch (v) {
        case true:
          this.startTimer();
          setTimeout(() =>{
            this.dbSettings = false;
          }, 60 * 1000)
          break;
        case false:
          clearInterval(this.timer);
          this.timeout = 60;
          break;
      }
    }
  },
  computed: {
    dbDataValid() {
      return (
        !this.errors.any() &&
        this.link_db &&
        this.remote_url &&
        this.remote_port 
      ); 
    },
    dbData() {
      return this.$store.state.db;
    },
    isThemedark() {
      return this.$store.state.theme;
    },
    window() {
      if (this.app) {
        const remote = window.require("electron").remote;
        return remote.getCurrentWindow();
      }
    },
    textColor() {
      return {
        "text-white":
          this.$store.state.mainLayoutType === "vertical" &&
          this.navbarColorLocal !=
            (this.$store.state.theme === "dark" ? "#10163a" : "#fff"),
      };
    },

    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
        ? "#10163a"
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-white":
          (this.navbarColor != "#10163a" &&
            this.$store.state.theme === "dark") ||
          (this.navbarColor != "#fff" && this.$store.state.theme !== "dark"),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default") return "navbar-default";
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },
  },
  methods: {
    updateDB() {
      this.checkDB();
    },
    getDB() {
      return `${this.protocol}://${this.remote_username}:${this.remote_password}@${this.remote_url}:${this.remote_port}/${this.link_db}`;
    },
    checkDB() {
      let dbString = this.getDB();
      const db = new PouchDb(dbString, { skip_setup: true });
      db.info()
      .then(async (d) => {
        // The database exists.
        if(d.error) {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: d.reason,
          });
        } else {
          console.log(dbString);
          await idb.saveRecord({
            type: "database",
            db: dbString,
            allow_backups: this.allow_backups,
            create_db: this.create_db,
            link_db: this.link_db,
            remote_url: this.remote_url,
            remote_username: this.remote_username,
            remote_password: this.remote_password,
          });
          p.init(this.$pouch);
          this.$vs.notify({
            color: "success",
            title: "DB Connected",
            text: "DB found and connected. Sync will run in the background.",
          });
          this.dbSettings = false;
        }
      })
      .catch(e => {
        this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Database found and it was not created.",
          });
      });
    },
    async getDefultData() {
      await this.fill(
      [
        "db",
        "link_db",
        "remote_url",
        "remote_username",
        "allow_backups",
      ],
      "database"
    );
      if(this.db !== null) {
        var dbArray = this.db.split('/');
        this.link_db = dbArray[3];
      }
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.timeout--;
      }, 1000);
    },
    type(str) {
      var a = str.split(" ");
      var v = false;
      a.map((t) => {
        switch (t) {
          case "download":
            v = "Download";
            break;
          case "upload":
            v = "Upload";
            break;
        }
      });
      return v;
    },
    toggleTheme() {
      this.$store.dispatch(
        "updateTheme",
        this.isThemedark === "dark" ? "light" : "dark"
      );
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    closeApp() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Close Vue",
        text:
          "You are about to close Vue. Any unsaved data would be lost. Are you sure you want to proceed?",
        accept: () => {
          this.window.close();
        },
      });
    },
    async getRecord(type) {
      return await idb.getRecord(type);
    },
    async fill(a, t) {
      let d = (await this.getRecord(t)) || null;
      if (d) {
        for (let i = 0; i < a.length; i++) {
          const e = a[i];
          if (this.hasOwnProperty(e) && d.hasOwnProperty(e)) {
            this[`${e}`] = d[e];
          }
        }
        return d;
      }
      return false;
    },
  },
  created() {
    this.getDefultData();
  }
};
</script>
